// frontend/src/games/missions/zcMissionLabels.js
// Labels (ES) for ZodiacCrush daily missions.
// Keep this file UI-only: no API calls, no React.

const ES_LABEL = {
  // ===== Clears =====
  clear_element_any: 'Limpiá fichas (cualquier elemento) ✨',
  clear_element_fire: 'Limpiá fichas de Fuego 🔥',
  clear_element_water: 'Limpiá fichas de Agua 💧',
  clear_element_air: 'Limpiá fichas de Aire 🌬️',
  clear_element_earth: 'Limpiá fichas de Tierra 🪨',

  // ===== Combos =====
  combo_3: 'Hacé combos de 3+ ✨',
  combo3: 'Hacé combos de 3+ ✨',
  combo_4: 'Hacé combos de 4+ ⭐',
  combo4: 'Hacé combos de 4+ ⭐',
  combo_5: 'Hacé combos de 5+ 🌟',
  combo5: 'Hacé combos de 5+ 🌟',
  combo_reach: 'Hacé combos ⭐',

  // ===== Score =====
  score_reach: 'Alcanzá una puntuación 🎯',
  reach_score: 'Alcanzá una puntuación 🎯',
  score_in_n_moves: 'Sumá puntos en movimientos limitados 🎯',
  score_without_boosters: 'Sumá puntos sin usar boosters 🚫⚡',
  score_no_boosters: 'Sumá puntos sin usar boosters 🚫⚡',

  // ===== Specials =====
  activate_stripe: 'Activá rayos ⚡',
  activate_stripe_via_star: 'Activá rayos usando estrellas ⚡⭐',
  activate_stripe_via_swap: 'Activá rayos con un swap ⚡',
  make_star: 'Creá estrellas ⭐',
  activate_any_special: 'Activá cualquier especial ✨',

  // ===== Cascades =====
  cascade_2p: 'Lográ cascadas de 2+ 🔁',
  cascade_3p: 'Lográ cascadas de 3+ 🔁',
  cascade_4p: 'Lográ cascadas de 4+ 🔁',
  cascade_4_plus: 'Lográ cascadas de 4+ 🔁',
  cascade_5_plus: 'Lográ cascadas de 5+ 🔁',
  cascades_reach: 'Lográ cascadas 🔁',

  // ===== Burst / Explosions =====
  burst_clear_any: 'Hacé una explosión 💥',
  burst_clear_fire: 'Hacé una explosión de Fuego 💥🔥',
  burst_clear_water: 'Hacé una explosión de Agua 💥💧',
  burst_clear_air: 'Hacé una explosión de Aire 💥🌬️',
  burst_clear_earth: 'Hacé una explosión de Tierra 💥🪨',

  // ===== Utility =====
  multi_element_move: 'Limpiá varios elementos en un solo movimiento ✨',
  play_moves: 'Realizá movimientos 🎮',
  win_runs: 'Completá partidas 🏁',
  use_booster: 'Usá un booster',
  use_booster_hint: 'Usá Pista 💡',
  use_booster_reroll: 'Usá Reordenar 🔄',
};

function normalizeType(type) {
  return String(type || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_');
}

/**
 * Returns a Spanish label for a daily mission.
 * @param {object} m mission object (expects { type })
 */
export function getMissionLabel(m) {
  const t = normalizeType(m?.type);
  if (t && ES_LABEL[t]) return ES_LABEL[t];

  // Friendly semantic fallbacks
  if (t.includes('clear')) return 'Limpiá fichas ✨';
  if (t.includes('combo')) return 'Hacé combos ⭐';
  if (t.includes('score')) return 'Sumá puntos 🎯';
  if (t.includes('stripe') || t.includes('rayo')) return 'Activá rayos ⚡';
  if (t.includes('star') || t.includes('estrella')) return 'Creá estrellas ⭐';
  if (t.includes('cascade')) return 'Lográ cascadas 🔁';
  if (t.includes('burst') || t.includes('explos')) return 'Hacé explosiones 💥';
  if (t.includes('booster') || t.includes('boost')) return 'Usá un booster 🎁';

  // Last resort (should almost never be seen)
  return 'Misión';
}

/**
 * Formats progress like "12/40".
 * @param {object} m mission object (expects { progress, target })
 */
export function getMissionProgressText(m) {
  const p = Math.max(0, Number(m?.progress || 0) || 0);
  const t = Math.max(0, Number(m?.target || 0) || 0);
  if (!t) return String(p);
  return `${p}/${t}`;
}